import _ from "lodash";
import { createTheme } from "@mui/material";
import { softShadows, strongShadows } from "./shadows";
import { colors, responsiveFontSizes } from "@mui/material";

// const baseOptions = {
//   direction: "ltr",
//   typography: {
//     fontFamily: "'K2D', sans-serif",
//     allVariants: {
//       color: "#000", // Set all text variants to black
//     },
//   },
//   palette: {
//     type: "light", // Ensure the theme is light
//     text: {
//       primary: "#000", // Primary text color
//       secondary: "#333", // Secondary text color (slightly lighter)
//     },
//     background: {
//       default: "#fff", // Background to white for better contrast
//       paper: "#f9f9f9", // Paper elements background
//     },
//   },
//   overrides: {
//     MuiTypography: {
//       root: {
//         color: "#000", // Ensure typography components have black text
//       },
//     },
//     MuiInputBase: {
//       root: {
//         color: "#000", // Input text color
//       },
//     },
//     MuiButton: {
//       root: {
//         color: "#000", // Button text color
//       },
//     },
//   },
// };

const baseOptions = {
  direction: "ltr",
  typography: {
    fontFamily: "'K2D', sans-serif",
    allVariants: {
      color: "#000", // Set all text variants to black
    },
  },
  palette: {
    type: "light", // Ensure the theme is light
    text: {
      primary: "#000", // Primary text color
      secondary: "#333", // Secondary text color
    },
    background: {
      default: "#fff", // Background to white for better contrast
      paper: "#f9f9f9", // Paper elements background
    },
  },
  overrides: {
    MuiTypography: {
      root: {
        color: "#000", // Ensure typography components have black text
      },
    },
    MuiInputBase: {
      root: {
        color: "#000", // Input text color
        backgroundColor: "#fff", // Input background
      },
      input: {
        color: "#000", // Ensure text entered in inputs is black
        "&::placeholder": {
          color: "#555", // Placeholder text color
          opacity: 1,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: "#fff", // Input field background
        borderRadius: "8px",
      },
      input: {
        color: "#000", // Text color
        "&:-webkit-autofill": {
          WebkitBoxShadow: "0 0 0 100px #fff inset",
          WebkitTextFillColor: "#000", // Autofill text color
        },
      },
    },
    MuiInput: {
      root: {
        color: "#000", // Text color
      },
      underline: {
        "&::before": {
          borderBottom: "1px solid #000", // Black underline
        },
        "&:hover:not(.Mui-disabled):before": {
          borderBottom: "1px solid #000",
        },
        "&::after": {
          borderBottom: "2px solid #000", // Active underline
        },
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: "#fff", // Input field background
        color: "#000", // Input text color
        "&:hover": {
          backgroundColor: "#f5f5f5", // Slightly lighter on hover
        },
        "&.Mui-focused": {
          backgroundColor: "#fff",
        },
      },
    },
  },
};

// Create a theme with the base options
const theme = createTheme(baseOptions);

const themesOptions = [
  {
    name: "LIGHT",
    palette: {
      text: {
        primary: "#000", // Set primary text color to black
        secondary: "#000", // Set secondary text color to black
      },
    },
    overrides: {
      MuiFilledInput: {
        root: { backgroundColor: "#f8f7f7", color: "#000" },
      },
      MuiAppBar: {
        colorPrimary: {
          // color: "#fff",
          backgroundColor: "none",
        },
        colorDefault: {
          backgroundColor: "none",
        },
      },
      MuiSelect: {
        icon: {
          top: "calc(50% - 20px)",
          color: "#fff",
          right: "0",
          position: "absolute",
          pointerEvents: "none",
          background: "rgba(255, 255, 255, 0.025)",
          borderRadius: "50%",
          padding: "8px",
        },
      },
      MuiButton: {
        root: {
          "&:hover": {
            backgroundColor: "none",
          },
        },
        containedSecondary: {
          color: "#353434",
          filter: "drop-shadow(0px 13px 27px rgba(0, 0, 0, 0.25))",
          padding: "10px 35px",
          fontSize: "12px",
          fontFamily: "Good Times W00 Bold",
          fontWeight: "400",
          lineHeight: "21px",
          borderRadius: "50px",
          backgroundColor: "#fff",
          height: "48px",
          letterSpacing: "1.26px",
          whiteSpace: "pre",
          "&:hover": {
            color: "#ffffff",
            background:
              "linear-gradient(93.14deg, #FFB000 -20.75%, #FF564D 11.84%, #FF0098 53.76%, #5D00C1 102.96%)",
            border: "1px solid #a102afcc",
          },
          "@media(max-width:767px)": {
            fontSize: "12px !important",
          },
        },
        containedPrimary: {
          color: "#fff",
          filter: "drop-shadow(0px 13px 27px rgba(0, 0, 0, 0.25))",
          padding: "10px 35px",
          fontSize: "12px",
          letterSpacing: "1.26px",
          background:
            "linear-gradient(93.34deg, #FF6F37 6.82%, #FF2676 35.9%, #B801AA 68.08%, #7101BC 101.4%)",
          fontFamily: "Good Times W00 Bold",
          fontWeight: "400",
          lineHeight: "21px",
          borderRadius: "50px",
          backgroundColor: "#898989",
          height: "48px",
          whiteSpace: "pre",
          "&:hover": {
            color: "#000",
            boxShadow:
              "0 1px 0 0 #ff00cd, 0 -1px 0 0 #7d00b9, 1px 0 0 0 #f5673f, -1px 0 0 0 #f5673f, 1px -1px 0 0 #f5673f, -1px 1px 0 0 #f5673f, 1px 1px 0 0 #f5673f, -1px -1px 0 0 #f5673f",
            background: "#fff !important",
          },
          "@media(max-width:767px)": {
            fontSize: "10px !important",
          },
        },
      },
      MuiOutlinedInput: {
        input: {
          borderRadius: "10px",
          "&:-webkit-autofill": {
            "-webkit-background-clip": "text !important",
            // transitionDelay: "9999s",
            "caret-color": "transparent",
            "-webkit-box-shadow": "0 0 0 100px #fff inset",
            "-webkit-text-fill-color": "#000",
          },
          "&:-internal-autofill-selected": {
            color: "#fff",
          },
        },
      },
      MuiInputBase: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#000",
        },
        input: {
          fontSize: "13px",
          fontWeight: "200",
          "&::placeholder": {
            opacity: 1,
            color: "#a1a1a1",
          },
        },
      },
    },
    typography: {
      fontFamily: "'K2D', sans-serif",
    },
    palette: {
      type: "dark",
      action: {
        active: colors.blueGrey[600],
      },
      background: {
        default: "#f5f5f5",
        disabled: "#212226a1",
        dark: "#1c2025",
        paper: "#FFFFFF",
        section: "#D5D7DB",
        subpaper:
          "linear-gradient(180deg, #021431 -89.43%, rgb(2 4 8 / 0%) 50.33%)",
        header: "linear-gradient(180deg, #424344 0%, #232427 100%)",
        brown: "#f5f5f5",
        table: "#545252",
        button: "#FFFFFF",
        buttontext: "#FFFFFF",
      },
      primary: {
        main: "#FFFFFF",
      },
      secondary: {
        main: "#000",
      },
      text: {
        // primary: colors.blueGrey[900],
        // secondary: colors.blueGrey[600],
        primary: "#000", // Set primary text color to black
        secondary: "#000", // Set secondary text color to black
      },
    },
    shadows: softShadows,
  },
  {
    name: "DARK",
    overrides: {
      MuiAppBar: {
        colorPrimary: {
          color: "#fff",
          // backgroundColor: "#212226",
        },
        colorDefault: {
          backgroundColor: "none",
        },
      },

      MuiAccordionSummary: {
        root: {
          // background: "#171616",
          background: "rgba(255, 255, 255, 0.05)",
          borderRadius: "15px 15px 0px 0px",
        },
      },
      MuiAccordionDetails: {
        root: {
          background: "rgba(255, 255, 255, 0.025)",
          borderRadius: "0px 0px 15px 15px",
        },
      },
      MuiSelect: {
        icon: {
          top: "calc(50% - 20px)",
          color: "#fff",
          right: "0",
          position: "absolute",
          pointerEvents: "none",
          background: "rgba(255, 255, 255, 0.025)",
          borderRadius: "50%",
          padding: "8px",
        },
      },
      MuiButton: {
        root: {
          "&:hover": {
            backgroundColor: "none",
          },
        },
        containedSecondary: {
          color: "#353434",
          filter: "drop-shadow(0px 13px 27px rgba(0, 0, 0, 0.25))",
          padding: "10px 35px",
          fontSize: "12px",
          fontFamily: "Good Times W00 Bold",
          fontWeight: "400",
          lineHeight: "21px",
          borderRadius: "50px",
          backgroundColor: "#fff",
          letterSpacing: "1.26px",
          height: "48px",
          whiteSpace: "pre",
          "&:hover": {
            color: "#ffffff",
            background:
              "linear-gradient(93.34deg, #FF6F37 6.82%, #FF2676 35.9%, #B801AA 68.08%, #7101BC 101.4%)",
          },
          "@media(max-width:767px)": {
            fontSize: "10px !important",
          },
        },
        containedPrimary: {
          color: "#fff",
          filter: "drop-shadow(0px 13px 27px rgba(0, 0, 0, 0.25))",
          padding: "10px 35px",
          fontSize: "12px",
          letterSpacing: "1.26px",
          background:
            "linear-gradient(93.34deg, #FF6F37 6.82%, #FF2676 35.9%, #B801AA 68.08%, #7101BC 101.4%)",
          fontFamily: "Good Times W00 Bold",
          fontWeight: "400",
          lineHeight: "21px",
          borderRadius: "50px",
          backgroundColor: "#898989",
          height: "48px",
          whiteSpace: "pre",
          "&:hover": {
            color: "#353434",
            background: "#fff !important",
            boxShadow:
              "0 1px 0 0 #ff00cd, 0 -1px 0 0 #7d00b9, 1px 0 0 0 #f5673f, -1px 0 0 0 #f5673f, 1px -1px 0 0 #f5673f, -1px 1px 0 0 #f5673f, 1px 1px 0 0 #f5673f, -1px -1px 0 0 #f5673f",
          },
          "@media(max-width:767px)": {
            fontSize: "10px !important",
          },
        },
      },
      MuiOutlinedInput: {
        input: {
          borderRadius: "10px",
          "&:-webkit-autofill": {
            "-webkit-background-clip": "text !important",
            // transitionDelay: "9999s",
            "caret-color": "transparent",
            "-webkit-box-shadow": "0 0 0 100px #101010 inset",
            "-webkit-text-fill-color": "#fff",
          },
          "&:-internal-autofill-selected": {
            color: "#fff",
          },
        },
      },

      MuiOutlinedInput: {
        root: {
          color: "white",
          position: "relative",
          borderRadius: "10px",
          background: "rgba(255, 255, 255, 0.05)",
          border: "1px solid #80808087",
        },
        notchedOutline: {
          borderColor: "transparent !important",
        },
      },
      MuiInputBase: {
        root: {
          backgroundColor: "#212226",
          color: "#fff",
        },
        input: {
          fontSize: "13px",
          fontWeight: "200",
          "&::placeholder": {
            opacity: 1,
            color: "#a1a1a1",
          },
        },
        multiline: {
          // backgroundColor: "#1E1E1E",
          border: "none",
          borderRadius: "10px",
        },
      },
    },
    typography: {
      fontFamily: "'K2D', sans-serif",
    },
    palette: {
      type: "dark",
      action: {
        active: "rgba(255, 255, 255, 0.54)",
        hover: "rgba(255, 255, 255, 0.04)",
        selected: "rgba(255, 255, 255, 0.08)",
        disabled: "rgba(255, 255, 255, 0.26)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        focus: "rgba(255, 255, 255, 0.12)",
      },
      background: {
        default: "#000000ed",
        dark: "#212226",
        paper: "rgba(255, 255, 255, 0.1)",
        section: "#213743",
        subpaper:
          "linear-gradient(180deg, #F1F5FC -89.43%, rgba(241, 245, 252, 0) 19.33%)",
        header: "linear-gradient(180deg, #424344 0%, #232427 100%)",
        brown: "#2B2C31",
        table: "#212226",
        button: "#FFFFFF",
        buttontext: "#212226",
      },
      primary: {
        main: "#FFFFFF",
      },
      secondary: {
        main: "rgba(255, 255, 255, 0.5)",
      },
      text: {
        primary: "#e6e5e8",
        secondary: "#adb0bb",
      },
    },
    shadows: strongShadows,
  },
];

export const createTheming = (config = {}) => {
  let themeOptions = themesOptions.find((theme) => theme.name === config.theme);

  if (!themeOptions) {
    console.warn(new Error(`The theme ${config.theme} is not valid`));
    [themeOptions] = themesOptions;
  }

  let theme = createTheme(
    _.merge({}, baseOptions, themeOptions, { direction: config.direction })
  );

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
